module.exports = __webpack_public_path__ + "img/grey.a5870be1.png";